/* global Swiper */
// **********************************************************
// Game slider
// **********************************************************

const gameSliderElements = document.querySelectorAll('[data-slider="game-slider"]');
const gameSliderOptions = {
  slidesPerView: 'auto',
  freeMode: true,
  spaceBetween: 20,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    1200: {
      spaceBetween: 94,
    },
  },
};

gameSliderElements.forEach((el) => {
  const gameSliderParent = el.closest('.sc-game');
  const arrowRight = gameSliderParent.querySelector('.arrow-right');
  const arrowLeft = gameSliderParent.querySelector('.arrow-left');
  gameSliderOptions.navigation.nextEl = arrowRight;
  gameSliderOptions.navigation.prevEl = arrowLeft;
  // eslint-disable-next-line no-new
  new Swiper(el, gameSliderOptions);
});

// **********************************************************
// Game Tab
// **********************************************************

const gameNavTabLink = document.querySelectorAll('.game__tab-link');
const videoWrapper = document.querySelector('#video-wrapper');
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const activeSlug = urlParams.get('active');

// scroll to video
function scrollTo() {
  const viewHeight = window.innerHeight;
  const playerHeight = document.querySelector('.game__tab-content.is-active .video__image').offsetHeight;

  if (playerHeight < viewHeight) {
    document.querySelector('#video-scroll-to').scrollIntoView({
      behavior: 'smooth',
    });
  } else {
    document.querySelector('.game__tab-content.is-active .video__image').scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const activeVideo = document.querySelector('.game__tab-content.is-active');
  if (activeVideo) {
    videoWrapper.style.height = `${activeVideo.clientHeight}px`;
    if (activeSlug) {
      scrollTo();
    }
  }
});

// Close tab content
const gameCloseTabContents = (gameTabNavParent) => {
  const tabContentElems = gameTabNavParent.querySelectorAll('[data-tab-content]');
  gameNavTabLink.forEach((elem) => {
    elem.classList.remove('is-active');
  });
  tabContentElems.forEach((contentElem) => {
    contentElem.classList.remove('is-active');
  });
};

function stopVideo() {
  const iframes = document.querySelectorAll('iframe.video__iframe-container');
  iframes.forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  });
}

// Open specific tab
gameNavTabLink.forEach((el, index) => {
  el.addEventListener('click', () => {
    const slug = el.getAttribute('data-slug');
    const gameTabNavParent = el.closest('[data-tab]');
    const gameTabContentWrapper = gameTabNavParent.querySelector('[data-tab-wrapper]');
    const gameTargetTabContent = gameTabContentWrapper.querySelectorAll('[data-tab-content]')[index];

    stopVideo();
    scrollTo();

    gameCloseTabContents(gameTabNavParent);
    setTimeout(() => {
      gameTargetTabContent.classList.add('is-active');
      const gameTabContentHeight = `${gameTargetTabContent.clientHeight}px`;
      gameTabContentWrapper.style.height = gameTabContentHeight;
    }, 100);
    el.classList.add('is-active');
    if (history.pushState) {
      const newurl = `${window.location.href.split('?')[0]}?active=${slug}`;
      window.history.pushState({ path: newurl }, '', newurl);
    }
  });
});
